<template>
  <div class="column is-one-third-desktop is-half-tablet recipe-list--recipe">
    <div class="card">
      <div
        class="card-image recipe-list--recipe--photo-wrapper"
        v-if="photoIsProcessing || imageUrl"
      >
        <figure class="image is-16by9">
          <img
            v-if="imageUrl"
            :src="imageUrl"
            :alt="$t('recipeImage')"
            class="recipe-list--recipe--photo"
          />
          <svg
            class="recipe-list--recipe--photo-spinner"
            v-if="photoIsProcessing"
            width="38"
            height="38"
            viewBox="0 0 38 38"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#00d1b2"
          >
            <g fill="none" fill-rule="evenodd">
              <g transform="translate(1 1)" stroke-width="2">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    from="0 18 18"
                    to="360 18 18"
                    dur="1s"
                    repeatCount="indefinite"
                  />
                </path>
              </g>
            </g>
          </svg>
          <p class="title is-4 recipe-list--recipe--name-overlay">
            {{ recipe.name }}
          </p>
        </figure>
      </div>
      <div class="card-content">
        <p v-if="!imageUrl" class="title is-4">
          {{ recipe.name }}
        </p>
        <p class="buttons is-hidden-print">
          <button
            v-on:click="primaryAction(recipe)"
            class="button is-small is-primary recipe-list--recipe--primary-action-button"
          >
            {{ primaryActionLabel }}
          </button>

          <label
            :for="`file-picker-${recipe._id}`"
            class="button is-small recipe-list--recipe--add-photo-button"
          >
            {{ $t("addPhoto") }}
          </label>
          <input
            type="file"
            accept="image/jpeg"
            :id="`file-picker-${recipe._id}`"
            class="is-sr-only recipe-list--recipe--add-photo-file-picker"
            @change="fileSelected(recipe, $event)"
          />
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
const imageBlobReduce = require("image-blob-reduce")();

export default Vue.extend({
  name: "Recipe",
  props: ["recipe", "primaryActionLabel"],
  data: function () {
    return {
      photoIsProcessing: false,
    };
  },
  computed: {
    imageUrl: function () {
      if (this.recipe._attachments && this.recipe._attachments["image.jpg"]) {
        return (
          "data:image/jpeg;base64," + this.recipe._attachments["image.jpg"].data
        );
      } else {
        return null;
      }
    },
  },
  methods: {
    primaryAction: function (recipe) {
      this.$emit("primaryActionSelected", recipe);
    },
    fileSelected: async function (recipe, event) {
      this.photoIsProcessing = true;
      const blob = await imageBlobReduce.toBlob(event.target.files[0], {
        max: 1000,
      });
      await this.$store.dispatch("addImageToRecipe", {
        recipe,
        image: blob,
      });
      this.photoIsProcessing = false;
    },
  },
  components: {},
});
</script>

<style scoped>
.recipe-list--recipe--photo {
  object-fit: cover;
}
.recipe-list--recipe--name-overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 1.5rem;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
  color: white;
}
.recipe-list--recipe--photo-spinner {
  position: absolute;
  top: 0;
  width: 100%;
  margin-top: 25%;
}
</style>
<i18n>
{
  "en": {
    "recipeImage": "An image of the dish",
    "addPhoto": "Add photo"
  },
  "de": {
    "recipeImage": "Ein Bild des Rezepts",
    "addPhoto": "Foto hinzufügen"
  }
}
</i18n>
